import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

/**
 * Excavator glyph for hub cards. Font Awesome Free does not ship `faExcavator` in
 * `@fortawesome/free-solid-svg-icons` (it exists on fontawesome.com but is not in the free npm bundle).
 * Path from Material Design Icons “excavator” (Apache 2.0) - https://pictogrammers.com/library/mdi/icon/excavator/
 */
export const faExcavatorSolid: IconDefinition = {
    prefix: "fas",
    iconName: "excavator",
    icon: [
        24,
        24,
        [],
        "",
        "M18.5 18.5c.54 0 1 .46 1 1s-.46 1-1 1h-12c-.54 0-1-.46-1-1s.46-1 1-1zm0-1.5h-12C5.13 17 4 18.13 4 19.5S5.13 22 6.5 22h12a2.5 2.5 0 0 0 0-5m2.5-6h-3V7h-5l-3 4v5h12zm-9.46 0l1.96-2.5H16V11zM9.76 3.41L4.76 2L2 11.83c-.34 1.28.41 2.61 1.7 2.97l1.16.32l3.29-2.83l-3.88-1.08l1.88-6.75l2.79.78c.56.29 1.77 1.1 2.53 2.13L12.5 6h.44c-1.26-1.59-3.09-2.54-3.18-2.59",
    ],
};
